module.exports = __webpack_public_path__ + "static/carousel3-d6e6b80d7ba9f87b06b49aeac62c28c7.jpg";